import { useState } from "react";
import axios from "axios";
import { t } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function TestLogin() {
  const [f, setF] = useState({ username: "", passcode: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await axios.post(`${API}/test-login`, f);
      window.location.assign(`/sign-in?__clerk_ticket=${encodeURIComponent(data.ticket)}`);
    } catch (e2) { setErr(e2?.response?.data?.detail || t("Something went wrong")); setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="card stack-sm w-full max-w-[25rem]" data-testid="test-login-form">
      <p className="font-semibold">{t("Test account")}</p>
      <p className="text-xs faint -mt-1">{t("Sign in with a user name and passcode, no email needed.")}</p>
      <input className="field" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} placeholder={t("User name")} autoComplete="username" required data-testid="test-login-username" />
      <input className="field" type="password" value={f.passcode} onChange={(e) => setF({ ...f, passcode: e.target.value })} placeholder={t("Passcode")} autoComplete="current-password" required data-testid="test-login-passcode" />
      {err && <p className="text-sm text-[var(--status-error)]" data-testid="test-login-error">{err}</p>}
      <button className="btn btn-primary" disabled={busy} data-testid="test-login-submit">{t(busy ? "Signing in…" : "Sign in")}</button>
    </form>
  );
}
